// extracted by mini-css-extract-plugin
export default {"timeslotsPage":"styles_timeslotsPage__ybXsg","timeslotsContent":"styles_timeslotsContent__QSYcK"};